import { Modal } from '@maxtropy/components';
import { apiV2ComprehensiveLabelUpsertPost } from '@maxtropy/device-customer-apis-v2';
import { Form, Input } from 'antd';
import { useEffect, useMemo, useState } from 'react';
interface Iprops {
  opType: string;
  id?: number;
  name?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  type?: string;
}

const CircuitLabelModal = ({ opType, id, name, onConfirm, onCancel, type }: Iprops) => {
  const [form] = Form.useForm();
  const modalTile = useMemo(() => (opType === 'add' ? '新建标签' : '编辑标签'), [opType]);
  const [loading, setLoding] = useState<boolean>(false);

  useEffect(() => {
    if (opType === 'edit') {
      form.setFieldsValue({ name });
    }
  }, [opType, name, form]);

  const confirmBtn = () => {
    form.validateFields().then(async valid => {
      setLoding(true);
      apiV2ComprehensiveLabelUpsertPost({ ...valid, id: id, type })
        .then(res => {
          setLoding(false);
          onConfirm?.();
        })
        .finally(() => {
          setLoding(false);
        });
    });
  };

  return (
    <Modal title={modalTile} open width={500} onOk={confirmBtn} confirmLoading={loading} onCancel={() => onCancel?.()}>
      <Form form={form}>
        <Form.Item
          label="标签名称"
          name="name"
          rules={[
            {
              required: true,
              pattern: /^.{1,20}$/,
              message: '请输入1-20个字符',
            },
            {
              validator(rule, value, callback) {
                if (value && value.includes(',')) {
                  return Promise.reject(`不支持输入","`);
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder="请输入"></Input>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CircuitLabelModal;
